import React, { useState } from 'react';
import { IonCard, IonCardContent, IonIcon } from '@ionic/react';
import { chevronDownOutline, chevronUpOutline } from 'ionicons/icons';
import './CatalogoSection.css';

let sectionSequence = 0;
type Props = {
  title: string;
  description: string;
  icon: string;
  iconColor?: string;
  iconBackground?: string;
  className?: string;
  expanded?: boolean;
  onExpandedChange?: (expanded: boolean) => void;
  children: React.ReactNode;
};

const CatalogoSection: React.FC<Props> = ({ title, description, icon, iconColor = '#6b7280', iconBackground, className = '', expanded, onExpandedChange, children }) => {
  const [localExpanded, setLocalExpanded] = useState(false);
  const [bodyId] = useState(() => `catalogo-section-${++sectionSequence}`);
  const isExpanded = expanded ?? localExpanded;
  return <IonCard className={`catalogo-form-card catalogo-collapsible-card ${className}`}>
    <IonCardContent>
      <button type="button" className="catalogo-section-trigger" aria-label={title} aria-expanded={isExpanded} aria-controls={bodyId}
        onClick={() => onExpandedChange ? onExpandedChange(!isExpanded) : setLocalExpanded(!isExpanded)}>
        <span className="catalogo-section-icon" style={{ backgroundColor: iconBackground }}><IonIcon icon={icon} style={{ color: iconColor, fontSize: '20px' }} /></span>
        <span className="catalogo-section-heading">
          <span className="catalogo-section-title">{title}</span>
          <span className="catalogo-section-subtitle">{description}</span>
        </span>
        <IonIcon className="catalogo-section-chevron" icon={isExpanded ? chevronUpOutline : chevronDownOutline} aria-hidden="true" />
      </button>
      <div id={bodyId} className="catalogo-section-body" hidden={!isExpanded}>{children}</div>
    </IonCardContent>
  </IonCard>;
};

export default CatalogoSection;
